const $fac67fab423f213c$var$kernelX = [
    [
        -1,
        0,
        1
    ],
    [
        -2,
        0,
        2
    ],
    [
        -1,
        0,
        1
    ]
];
const $fac67fab423f213c$var$kernelY = [
    [
        -1,
        -2,
        -1
    ],
    [
        0,
        0,
        0
    ],
    [
        1,
        2,
        1
    ]
];
const $fac67fab423f213c$var$intensityThreshold = 0.5;
function $fac67fab423f213c$export$cfc135d03bdc864d({ imageData: imageData, columns: columns }) {
    const pixelAt = (x, y)=>imageData[x + columns * y] || 0;
    const rows = imageData.length / columns;
    const sobelData = [];
    for(let y = 0; y < rows; y++)for(let x = 0; x < columns; x++){
        const pixelX = $fac67fab423f213c$var$kernelX[0][0] * pixelAt(x - 1, y - 1) + $fac67fab423f213c$var$kernelX[0][1] * pixelAt(x, y - 1) + $fac67fab423f213c$var$kernelX[0][2] * pixelAt(x + 1, y - 1) + $fac67fab423f213c$var$kernelX[1][0] * pixelAt(x - 1, y) + $fac67fab423f213c$var$kernelX[1][1] * pixelAt(x, y) + $fac67fab423f213c$var$kernelX[1][2] * pixelAt(x + 1, y) + $fac67fab423f213c$var$kernelX[2][0] * pixelAt(x - 1, y + 1) + $fac67fab423f213c$var$kernelX[2][1] * pixelAt(x, y + 1) + $fac67fab423f213c$var$kernelX[2][2] * pixelAt(x + 1, y + 1);
        const pixelY = $fac67fab423f213c$var$kernelY[0][0] * pixelAt(x - 1, y - 1) + $fac67fab423f213c$var$kernelY[0][1] * pixelAt(x, y - 1) + $fac67fab423f213c$var$kernelY[0][2] * pixelAt(x + 1, y - 1) + $fac67fab423f213c$var$kernelY[1][0] * pixelAt(x - 1, y) + $fac67fab423f213c$var$kernelY[1][1] * pixelAt(x, y) + $fac67fab423f213c$var$kernelY[1][2] * pixelAt(x + 1, y) + $fac67fab423f213c$var$kernelY[2][0] * pixelAt(x - 1, y + 1) + $fac67fab423f213c$var$kernelY[2][1] * pixelAt(x, y + 1) + $fac67fab423f213c$var$kernelY[2][2] * pixelAt(x + 1, y + 1);
        const intensity = Math.sqrt(Math.pow(pixelX, 2) + Math.pow(pixelY, 2));
        const maskChar = intensity > $fac67fab423f213c$var$intensityThreshold ? " " : "";
        sobelData.push(maskChar);
    }
    return sobelData;
}


function $799272dfed1058ce$export$42d15c42c3638137({ imageData: imageData }) {
    const ans = [];
    for(let i = 0; i < imageData.length; i += 4){
        const r = imageData[i];
        const g = imageData[i + 1];
        const b = imageData[i + 2];
        // CIE 1931 conversion
        const intensity = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        ans.push(intensity / 256);
    }
    return ans;
}


async function $820877bea407f5fe$export$a0649b6a2895bcd6({ element: element, eventName: eventName }) {
    return new Promise((resolve)=>element.addEventListener(eventName, resolve));
}
async function $820877bea407f5fe$export$58d6a4bf07475873(ms) {
    if (ms <= 0) return;
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


const $3d49c7f1bc04b0a9$var$ASCII_CHARACTERS = "$#@MXxoi;:,. ".split("");
const $3d49c7f1bc04b0a9$var$COLUMNS = 80;
const $3d49c7f1bc04b0a9$var$getTextColor = $3d49c7f1bc04b0a9$var$buildGetTextColor();
function $3d49c7f1bc04b0a9$export$7bdb1ca08f81d755({ video: video, canvas: asciiCanvas, frameRate: frameRate, mirror: mirror = false }) {
    const { fontSize: fontSize, scaleFactor: scaleFactor } = $3d49c7f1bc04b0a9$var$prepareAsciiCanvas({
        canvas: asciiCanvas,
        video: video
    });
    const fontSizeWithSpacing = fontSize;
    const lineHeight = fontSize * 1.2;
    const frameGenerator = $3d49c7f1bc04b0a9$var$generateFrames({
        videoElement: video,
        scaleFactor: scaleFactor,
        mirror: mirror
    });
    const context = asciiCanvas.getContext("2d");
    const msBetweenFrames = 1e3 / frameRate;
    let finished = false;
    setTimeout(async ()=>{
        for (const frame of frameGenerator){
            if (finished) {
                frameGenerator.return();
                break;
            }
            const startTime = Date.now();
            const imageData = frame.data;
            const intensities = (0, $799272dfed1058ce$export$42d15c42c3638137)({
                imageData: imageData
            });
            const ascii = $3d49c7f1bc04b0a9$var$frameToAscii({
                imageData: intensities
            });
            context.clearRect(0, 0, asciiCanvas.width, asciiCanvas.height);
            const rows = ascii.length / $3d49c7f1bc04b0a9$var$COLUMNS;
            for(let row = 0; row < rows; row++){
                const asciiLine = ascii.slice(row * $3d49c7f1bc04b0a9$var$COLUMNS, (row + 1) * $3d49c7f1bc04b0a9$var$COLUMNS);
                const yOffset = (row + 1) * lineHeight;
                asciiLine.forEach((asciiChar, index)=>{
                    context.fillText(asciiChar, index * fontSizeWithSpacing, yOffset);
                });
            }
            const elapsedTime = Date.now() - startTime;
            await (0, $820877bea407f5fe$export$58d6a4bf07475873)(Math.max(20, msBetweenFrames - elapsedTime));
        }
    }, 0);
    return ()=>{
        finished = true;
    };
}
function $3d49c7f1bc04b0a9$var$frameToAscii({ imageData: imageData }) {
    const edgesMask = (0, $fac67fab423f213c$export$cfc135d03bdc864d)({
        imageData: imageData,
        columns: $3d49c7f1bc04b0a9$var$COLUMNS
    });
    const ascii = imageData.map($3d49c7f1bc04b0a9$var$valueToAscii);
    const asciiWithEdges = ascii.map((value, i)=>edgesMask[i] || value);
    return asciiWithEdges;
}
function $3d49c7f1bc04b0a9$var$valueToAscii(value) {
    const index = Math.floor(value * $3d49c7f1bc04b0a9$var$ASCII_CHARACTERS.length);
    return $3d49c7f1bc04b0a9$var$ASCII_CHARACTERS[index];
}
function $3d49c7f1bc04b0a9$var$prepareAsciiCanvas({ canvas: canvas, video: video }) {
    const { width: width, height: height } = video.getBoundingClientRect();
    // Setting the dimension for video as well prevents any undesired resizing
    canvas.style.width = video.style.width = `${width}px`;
    canvas.style.height = video.style.height = `${height}px`;
    canvas.width = width;
    canvas.height = height;
    const fontSize = width / $3d49c7f1bc04b0a9$var$COLUMNS;
    const context = canvas.getContext("2d");
    context.font = `${fontSize.toFixed(2)}px monospace`;
    context.fillStyle = $3d49c7f1bc04b0a9$var$getTextColor(canvas);
    const pixelsPerChar = video.videoWidth / $3d49c7f1bc04b0a9$var$COLUMNS;
    const scaleFactor = 1 / pixelsPerChar;
    return {
        fontSize: fontSize,
        scaleFactor: scaleFactor
    };
}
function* $3d49c7f1bc04b0a9$var$generateFrames({ videoElement: videoElement, scaleFactor: scaleFactor, mirror: mirror }) {
    const canvas = document.createElement("canvas");
    canvas.width = videoElement.videoWidth * scaleFactor;
    canvas.height = videoElement.videoHeight * scaleFactor;
    const canvasContext = canvas.getContext("2d", {
        willReadFrequently: true
    });
    if (mirror) canvasContext.scale(-1, 1);
    while(true){
        canvasContext.drawImage(videoElement, 0, 0, mirror ? -canvas.width : canvas.width, canvas.height);
        const imageData = canvasContext.getImageData(0, 0, canvas.width, canvas.height);
        yield imageData;
    }
}
function $3d49c7f1bc04b0a9$var$buildGetTextColor() {
    let textColor;
    return (canvas)=>{
        if (!textColor) textColor = getComputedStyle(canvas).color;
        return textColor;
    };
}



async function $4ea609bc1bea3734$export$c4401a585b233e4b(videoElement) {
    const videoFeed = await navigator.mediaDevices.getUserMedia({
        video: true
    });
    videoElement.srcObject = videoFeed;
    videoElement.play();
}


const $35da740d59af89ba$var$FRAME_RATE = 30;
let $35da740d59af89ba$var$stopCurrentStreaming = null;
let $35da740d59af89ba$var$currentVideoFile = null;
document.getElementById("enable-webcam").addEventListener("click", $35da740d59af89ba$var$runAsciiShaderOnWebcamFeed);
document.getElementById("user-submitted-video").addEventListener("change", async (evt)=>{
    const videoFile = evt.target.files[0];
    $35da740d59af89ba$var$currentVideoFile = videoFile;
    if (!videoFile) return;
    $35da740d59af89ba$var$runAsciiShaderOnVideoFile({
        videoFile: videoFile
    });
});
document.getElementById("stop").addEventListener("click", $35da740d59af89ba$var$reset);
window.addEventListener("orientationchange", async ()=>{
    if (!$35da740d59af89ba$var$stopCurrentStreaming) return;
    const video = document.getElementById("video");
    const isWebcam = video.classList.contains("webcam");
    const currentTime = video.currentTime;
    $35da740d59af89ba$var$reset();
    if (isWebcam) $35da740d59af89ba$var$runAsciiShaderOnWebcamFeed();
    else {
        await $35da740d59af89ba$var$runAsciiShaderOnVideoFile({
            videoFile: $35da740d59af89ba$var$currentVideoFile
        });
        document.getElementById("video").currentTime = currentTime;
    }
});
async function $35da740d59af89ba$var$runAsciiShaderOnWebcamFeed() {
    $35da740d59af89ba$var$disableInputs();
    const startTime = Date.now();
    const video = $35da740d59af89ba$var$createVideo();
    video.classList.add("webcam");
    const canvas = $35da740d59af89ba$var$createCanvas();
    try {
        await (0, $4ea609bc1bea3734$export$c4401a585b233e4b)(video);
        $35da740d59af89ba$var$enableVideo();
        $35da740d59af89ba$var$mirrorVideo();
        await (0, $820877bea407f5fe$export$a0649b6a2895bcd6)({
            element: video,
            eventName: "canplay"
        });
        $35da740d59af89ba$var$stopCurrentStreaming = (0, $3d49c7f1bc04b0a9$export$7bdb1ca08f81d755)({
            video: video,
            canvas: canvas,
            frameRate: $35da740d59af89ba$var$FRAME_RATE,
            mirror: true
        });
    } catch (err) {
        console.error(err);
        const elapsedTime = Date.now() - startTime;
        const remainingTimeForSmoothAnimation = 3e3 - elapsedTime;
        await (0, $820877bea407f5fe$export$58d6a4bf07475873)(remainingTimeForSmoothAnimation);
        $35da740d59af89ba$var$reset();
    }
}
async function $35da740d59af89ba$var$runAsciiShaderOnVideoFile({ videoFile: videoFile }) {
    $35da740d59af89ba$var$disableInputs();
    const videoElement = $35da740d59af89ba$var$createVideo();
    videoElement.classList.add("video-upload");
    const videoReady = Promise.race([
        (0, $820877bea407f5fe$export$a0649b6a2895bcd6)({
            element: videoElement,
            eventName: "canplay"
        }).then(()=>({})),
        (0, $820877bea407f5fe$export$a0649b6a2895bcd6)({
            element: videoElement,
            eventName: "error"
        }).then(()=>({
                error: true
            }))
    ]);
    videoElement.src = URL.createObjectURL(videoFile);
    videoElement.load();
    videoElement.play();
    videoElement.setAttribute("controls", "");
    const { error: error } = await videoReady;
    if (error) {
        $35da740d59af89ba$var$reset();
        return;
    }
    const canvas = $35da740d59af89ba$var$createCanvas();
    $35da740d59af89ba$var$enableVideo();
    $35da740d59af89ba$var$stopCurrentStreaming = (0, $3d49c7f1bc04b0a9$export$7bdb1ca08f81d755)({
        video: videoElement,
        canvas: canvas,
        frameRate: $35da740d59af89ba$var$FRAME_RATE
    });
}
function $35da740d59af89ba$var$reset() {
    $35da740d59af89ba$var$stopCurrentStreaming?.();
    $35da740d59af89ba$var$stopCurrentStreaming = null;
    $35da740d59af89ba$var$disableVideo();
    $35da740d59af89ba$var$destroyVideo();
    $35da740d59af89ba$var$destroyCanvas();
    $35da740d59af89ba$var$enableInputs();
    document.getElementById("user-submitted-video").value = null;
}
function $35da740d59af89ba$var$disableInputs() {
    document.getElementById("enable-webcam").setAttribute("disabled", "");
    document.getElementById("user-submitted-video-button").setAttribute("aria-disabled", "true");
}
function $35da740d59af89ba$var$enableInputs() {
    document.getElementById("enable-webcam").removeAttribute("disabled");
    document.getElementById("user-submitted-video-button").removeAttribute("aria-disabled");
}
function $35da740d59af89ba$var$enableVideo() {
    document.getElementById("enable-webcam").classList.add("hidden", "live");
    document.getElementById("user-submitted-video-button").classList.add("hidden", "live");
}
function $35da740d59af89ba$var$disableVideo() {
    document.getElementById("enable-webcam").classList.remove("hidden", "live");
    document.getElementById("user-submitted-video-button").classList.remove("hidden", "live");
}
function $35da740d59af89ba$var$mirrorVideo() {
    document.getElementById("video").classList.add("mirrored");
}
function $35da740d59af89ba$var$createVideo() {
    const videoTemplate = document.getElementById("video-template");
    const video = videoTemplate.cloneNode();
    video.id = "video";
    video.classList.remove("hidden");
    videoTemplate.before(video);
    return video;
}
function $35da740d59af89ba$var$destroyVideo() {
    document.getElementById("video").remove();
}
function $35da740d59af89ba$var$createCanvas() {
    const canvasTemplate = document.getElementById("canvas-template");
    const canvas = canvasTemplate.cloneNode();
    canvas.id = "canvas";
    canvas.classList.remove("hidden");
    canvasTemplate.before(canvas);
    return canvas;
}
function $35da740d59af89ba$var$destroyCanvas() {
    document.getElementById("canvas").remove();
}


//# sourceMappingURL=index.d2e612d1.js.map
